import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FitCcDialogComponent } from './fit-cc-dialog.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FitCcDialogComponent],
  exports: [FitCcDialogComponent],
})
export class FitCcDialogModule {}
